import {
    FC,
    PropsWithChildren,
    ReactElement,
    useEffect,
} from 'react';

import { useLocalStorage } from 'react-use';

import { Token, tokenKey } from '../../../entities/@api/Sylius';
import { trackedOrderIdsKey } from '../../../entities/@shop/Order/Order';
import { GTMEvent } from '../../../entities/GTM/GTM';
import { generateGTMCompletedOrder } from '../../../entities/GTM/GTMRequests';
import { sendGTMEvent } from '../../../entities/GTM/GTMService';
import { fetchCart, removeCartLocally } from '../../../redux/@shop/cart/cartActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

export const ConnectedCheckoutThankYouPageWrapper: FC<PropsWithChildren> = ({
    children,
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const [trackedOrderIds, storeTrackedOrderIds] = useLocalStorage<string[]>(trackedOrderIdsKey, []);

    const hasFetchedCustomer = useTypedSelector(state => state.customerSlice.hasFetched);

    const cart = useTypedSelector(state => state.cartSlice.cart);

    useEffect((): void => {
        if (hasFetchedCustomer) {
            dispatch(fetchCart({
                skipPriceFetch: true,
            }));
        }
    }, [hasFetchedCustomer]);

    useEffect((): void => {
        const isTrackedAlready = trackedOrderIds?.includes(cart.id);

        if (cart.items.length === 0 || isTrackedAlready) {
            return;
        }

        const storedToken = localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);
        const tokenData = storedToken
            ? JSON.parse(storedToken) as Token
            : undefined;

        const customerId = tokenData?.customerId;
        const isNewCustomer = cart && !customerId;

        const gtmCompletedOrder = generateGTMCompletedOrder(cart, isNewCustomer);

        sendGTMEvent(GTMEvent.purchase, gtmCompletedOrder);

        const orderIdsToStore = trackedOrderIds
            ? [...trackedOrderIds, cart.id]
            : [cart.id];

        storeTrackedOrderIds(orderIdsToStore);

        dispatch(removeCartLocally());
    }, [cart]);

    return (
        <div>
            {children}
        </div>
    );
};
